import { documentationActions } from '../../actions/constant';

const {
  NEW_DOCUMENT_SIGN_SUCCESS,
  NEW_DOCUMENT_SIGN_REQUEST,
  NEW_DOCUMENT_SIGN_FAILURE,
  NEW_DOCUMENT_SIGN_RESET,
} = documentationActions;

const initialstate: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const newDocumentSignReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case NEW_DOCUMENT_SIGN_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
        isSuccess: true,
      };
      true;
    }

    case NEW_DOCUMENT_SIGN_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case NEW_DOCUMENT_SIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case NEW_DOCUMENT_SIGN_RESET:
      return initialstate;

    default:
      return state;
  }
};
